enum AuthContextEnum {
  tenantless = 'tenantless',
  tenant = 'tenant',
  subtenant = 'subtenant'
}

export default AuthContextEnum;
